import { COLOR, FONT_SIZE, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
  padding-top: 8px;
  border-top: 1px solid ${COLOR.GRAY200.code};
  border-bottom: 1px solid ${COLOR.GRAY200.code};
  font-size: ${FONT_SIZE.M}px;
  :first-of-type {
    border-top: none;
    margin-top: 0;
  }
`;

export const ButtonWrapper = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px;
`;

export const ParContentsHead = styled.p`
  font-size: ${FONT_SIZE.XS}px;
`;

export const ParContentsValue = styled.p`
  font-size: ${FONT_SIZE.XS}px;

  > span {
    font-size: ${FONT_SIZE.S}px;
    font-weight: ${FONT_WEIGHT.BOLD};
  }
`;
